module.exports = __webpack_public_path__ + "img/logo_evento.bb133a0d.png";